// const mac = require('getmac'); *** UNCOMMENT THIS WHEN IN ELECTRON
class Licensing {
    constructor() {

    }
    /**
     * GenerateClientKey : Creates a local license key that identifies this machine uniquely against the product.
     * ******* !!!!!!! MUST BE USED ONLY IN ELECTRON, ELSE THIS DOES NOT WORK!!!!!!
     * @return {string}
     */
    GenerateClientKey(ProductID) {
        return new Promise(function (resolve, reject) {
            mac.getMac(function (err, macAddress) {
                if (err) {
                    reject(err);
                    return;
                }
                console.log(macAddress);
                var retVal = "";
                var mac = macAddress.toString().replace(/-\s*/g, "");
                mac = mac.toString().replace(/:\s*/g, "");
                retVal = mac + "-" + ProductID.toString(16).padStart(2, "0");
                retVal = retVal.toUpperCase();
                resolve(retVal);
            });
        })
    }

    /**
     * GenerateClientKey : Creates a local license key that identifies this machine uniquely against the product.
     * @return {string}
     */
    GenerateClientKeyFromUserID(UserUID) {
        return new Promise(function (resolve, reject) {
            resolve(UserUID.toString());
        })
    }

    /**
     * DecryptKey : Decrypt the entered license key using the stored client key and input key
     * @param strLicense is the license received from the server
     * @param strKey is the local machine key including product id
     * @return {string}
     */
    DecryptKey(strLicence, strKey) {

        var LICENSE = function () {
            this.bLicValid = false;
            this.strDeviceIDChkSum = "";
            this.dtExpDate = new Date();
            this.iChkDigit1 = 0;
            this.iChkDigit2 = 0;
            this.strPID = 0; //** 0-255
            this.bExpire = false; //** True if expiry date needs to be evaluated. False is open licence
            this.bTrial = false;
            this.bDemo = false;
            this.bSpare1 = false; //** Spare T/F flag
            this.bSpare2 = false; //** Spare T/F flag
            this.iLevel = 0; //** Level between 0 and 7
            this.iConcurrentUsers = 0; //** Max 255 (concurrent) users
        };


        //#region Actual decryption
        var retVal = new LICENSE();

        if (ValidateLicenceFormat(strLicence)) {
            strLicence = Swap(strLicence, 14, 16); //5
            strLicence = Swap(strLicence, 4, 19); //4
            strLicence = Swap(strLicence, 8, 16); //3
            strLicence = Swap(strLicence, 6, 12); //2
            strLicence = Swap(strLicence, 1, 11); //1

            var strLicArray = strLicence.split('-');
            var strKeyArray = strKey.split('-');

            try {
                retVal.strDeviceIDChkSum = strLicArray[0];
                var strTmp = GetKeyCheckSum(strKeyArray[0]);
                if (strLicArray[0] != GetKeyCheckSum(strKeyArray[0])) {
                    retVal.bLicValid = false;
                } else {
                    retVal.dtExpDate = GetDate(strLicArray[1]);
                    retVal.iChkDigit1 = parseInt(strLicArray[2].substring(0, 1));
                    retVal.iChkDigit2 = parseInt(strLicArray[2].substring(3, 4));
                    retVal.strPID = strLicArray[2].substring(1, 3);
                    ExtractPermFlags(strLicArray[3], retVal);
                    retVal.bLicValid = (retVal.iChkDigit1 == CalcTotalChecksum(strLicence, 1) && retVal.iChkDigit2 == CalcTotalChecksum(strLicence, 2));
                }
            } catch (e) {
                retVal.bLicValid = false;
            }
        } else {
            retVal.bLicValid = false;
        }

        return retVal;

        //#endregion Actual decryption
    }

    Swap(strData, iPos1, iPos2) {
        var retVal = "";
        var array = strData.split('');
        var ch1 = array[iPos1 - 1];
        var ch2 = array[iPos2 - 1];
        array[iPos1 - 1] = ch2;
        array[iPos2 - 1] = ch1;
        var retVal = array.join().replace(/,\s*/g, "");

        return retVal;
    }

    ValidateLicenceFormat(strLic) {
        var bRetVal = true;

        if (strLic.length != 19)
            bRetVal = false;
        else {
            var strLicArray = strLic.split('-');

            if (strLicArray.length != 4) bRetVal = false;
            if (bRetVal) {
                if (strLicArray[0].length != 4 || strLicArray[1].length != 4 || strLicArray[2].length != 4 || strLicArray[3].length != 4) bRetVal = false;
                if (bRetVal) {
                    for (var i = 0; i < 4; i++) {
                        for (var o = 0; o < 4; o++) {
                            switch (strLicArray[i][o]) {
                                case 'A':
                                case 'B':
                                case 'C':
                                case 'D':
                                case 'E':
                                case 'F':
                                case '0':
                                case '1':
                                case '2':
                                case '3':
                                case '4':
                                case '5':
                                case '6':
                                case '7':
                                case '8':
                                case '9':
                                    break;
                                default:
                                    bRetVal = false;
                                    break;
                            }
                        }
                    }
                }
            }
        }

        return bRetVal;

    }

    GetKeyCheckSum(strUID) {
        var strRetVal = "";

        var str1 = strUID.toUpperCase();
        var str2 = strUID.toUpperCase();
        var str3 = strUID.toUpperCase();
        var str4 = strUID.toUpperCase();

        var strMask2 = "7111771117711177111771117711177111771117";
        var mask2 = strMask2.split('');
        var strMask3 = "1313131313131313131313131313131313131313";
        var mask3 = strMask3.split('');
        var strMask4 = "2345678912345678912345678912345678912345";
        var mask4 = strMask4.split('');

        str1 = str1.replace(/A\s*/g, "1");
        str2 = str2.replace(/A\s*/g, "6");
        str1 = str1.replace(/B\s*/g, "2");
        str2 = str2.replace(/B\s*/g, "5");
        str1 = str1.replace(/C\s*/g, "3");
        str2 = str2.replace(/C\s*/g, "4");
        str1 = str1.replace(/D\s*/g, "4");
        str2 = str2.replace(/D\s*/g, "3");
        str1 = str1.replace(/E\s*/g, "5");
        str2 = str2.replace(/E\s*/g, "2");
        str1 = str1.replace(/F\s*/g, "6");
        str2 = str2.replace(/F\s*/g, "1");

        str3 = str3.replace(/A\s*/g, "5");
        str4 = str4.replace(/A\s*/g, "4");
        str3 = str3.replace(/B\s*/g, "6");
        str4 = str4.replace(/B\s*/g, "6");
        str3 = str3.replace(/C\s*/g, "3");
        str4 = str4.replace(/C\s*/g, "1");
        str3 = str3.replace(/D\s*/g, "4");
        str4 = str4.replace(/D\s*/g, "3");
        str3 = str3.replace(/E\s*/g, "1");
        str4 = str4.replace(/E\s*/g, "2");
        str3 = str3.replace(/F\s*/g, "2");
        str4 = str4.replace(/F\s*/g, "5");

        var arr1 = str1.split('');
        var arr2 = str2.split('');
        var arr3 = str3.split('');
        var arr4 = str4.split('');

        var chk1 = 0;
        for (var i = 0; i < str1.length; i++) {
            chk1 += parseInt(arr1[i]) + 48;
        }
        //str1 = chk1.toString().substring(chk1.toString().length - 1, 1).join();
        str1 = chk1.toString()[chk1.toString().length - 1];

        var chk2 = 0;
        for (var i = 0; i < str2.length; i++) {
            chk2 += ((parseInt(arr2[i]) + 48) * (parseInt(mask2[i].toString()) + 0));
        }
        str2 = chk2.toString()[chk2.toString().length - 1];

        var chk3 = 0;
        for (var i = 0; i < str3.length; i++) {
            chk3 += ((parseInt(arr3[i]) + 48) * parseInt(mask3[i].toString()) + 0);
        }
        str3 = chk3.toString()[chk3.toString().length - 1];

        var chk4 = 0;
        for (var i = 0; i < str4.length; i++) {
            chk4 += (parseInt(arr4[i]) + 48) * parseInt(mask4[i].toString()) + 0;
        }
        str4 = chk4.toString()[chk4.toString().length - 1];

        strRetVal = str1 + str2 + str3 + str4;

        return strRetVal;
    }

    GetDate(strDt) {
        strDt = Swap(strDt, 1, 3);
        strDt = Swap(strDt, 4, 2);

        var strYear = strDt.substring(0, 1);
        var strMonth = strDt.substring(1, 2);
        var strDay = strDt.substring(2, 4);

        var iYear = 2000 + parseInt("1" + strYear, 16);
        if (iYear < new Date().getFullYear()) iYear += 16;
        var iMonth = parseInt(strMonth, 16);
        var iDay = parseInt(strDay, 16);

        var dtRetVal = new Date(iYear, iMonth - 1, iDay + 1, 0, 0, 0);

        return dtRetVal;
    }

    ExtractPermFlags(strFlags, pFlags) {

        function ToBinary(iNumber) {
            var digit = parseInt((iNumber % 2).toString());
            if (iNumber >= 2) {
                var remaining = parseInt(iNumber / 2);
                var remainingString = ToBinary(remaining);
                return (remainingString + digit).toString();
            }
            return digit.toString();
        }

        strFlags = Swap(strFlags, 2, 3);

        var iFlags = parseInt(strFlags, 16);

        strFlags = ToBinary(iFlags);
        strFlags = strFlags.padStart(16, "0");

        pFlags.bExpire = strFlags[0] == "1" ? true : false;
        pFlags.bTrial = strFlags[1] == "1" ? true : false;
        pFlags.bDemo = strFlags[2] == "1" ? true : false;
        pFlags.bSpare1 = strFlags[3] == "1" ? true : false;
        pFlags.bSpare2 = strFlags[4] == "1" ? true : false;
        pFlags.iLevel = parseInt(strFlags.substring(5, 8), 2);
        pFlags.iConcurrentUsers = parseInt(strFlags.substring(8, 16), 2);
    }

    CalcTotalChecksum(strLic, iType) {
        var strTmpLic = strLic.replace(/-\s*/g, "");
        var strChk = "";

        var strMask = "123456789123456789123456789";

        if (iType == 2) strMask = "7263544536271172635445362712";

        var iChk = 0;
        var iTmp = 0;
        var X = 0;

        for (var i = 0; i < strTmpLic.length; i++) {
            var ch = strTmpLic[i];
            if (ch == 'X') X = i;
            if (ch == 'Y') X = i;

            if (i != 8 && i != 11) {
                var y = parseInt(strMask[i]);
                switch (ch) {
                    case 'F':
                        iTmp = 15 * y;
                        break;
                    case 'E':
                        iTmp = 14 * y;
                        break;
                    case 'D':
                        iTmp = 13 * y;
                        break;
                    case 'C':
                        iTmp = 12 * y;
                        break;
                    case 'B':
                        iTmp = 11 * y;
                        break;
                    case 'A':
                        iTmp = 16 * y;
                        break;
                    default:
                        iTmp = (parseInt(ch)) * y;
                        break;
                }
                iChk += iTmp;

            }
        }
        strChk = iChk.toString()[iChk.toString().length - 1];

        if (iType == 1)
            strLic = strLic.replace(/X\s*/g, strChk);
        else
            strLic = strLic.replace(/Y\s*/g, strChk);

        X = parseInt(strChk);

        return X;
    }
}

export default Licensing;